import './components/hamburger';
import {hamburger} from "./components/hamburger";
import {authPopup} from "@/js/global/components/authPopup";
import {authHandler} from "@/js/global/components/authHandler";
import {cancelSubscription} from "@/js/global/components/cancelSubscription";
import {recaptchaBinder} from "@/js/global/components/recaptchaBinder";
import {showPassword} from "@/js/global/components/showPassword";
import {forgotPassword} from "@/js/global/components/forgotPassword";
import {forgotPasswordAjax} from "@/js/global/components/forgotPasswordAjax";
import {resendEmailAjax} from "@/js/global/components/resendEmailAjax";
import {Notif} from "@/js/global/components/Notif";


export const global = ()=>{
	hamburger();
	authPopup();
	authHandler();
	showPassword();
	cancelSubscription();
	recaptchaBinder();
	forgotPassword();
	forgotPasswordAjax();
	resendEmailAjax();
	Notif.init();
}


